export const USERS_FAVORITE_SUBMIT_REQUEST = 'users/favorite-submit-request'
export const USERS_FAVORITE_SUBMIT_SUCCESS = 'users/favorite-submit-success'
export const USERS_FAVORITE_SUBMIT_FAILED = 'users/favorite-submit-failed'
